import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import '../../styles/forms.css';

const TermsModal = ({ show, onClose }) => {
  if (!show) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ maxHeight: '80vh', overflow: 'auto' }}>
        <div className="modal-header">
          <h3>Terms and Conditions</h3>
          <button className="close-button" onClick={onClose}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>
        
        <div className="modal-body" style={{ padding: '20px' }}>
          <section className="terms-section">
            <h4>1. Agreement to Terms</h4>
            <p>These Terms of Service ("Terms") constitute a legally binding agreement between you and RoweBros Party Rentals ("we," "our," or "us") governing your access to and use of our website, services, and rentals.</p>
            <p>By accessing or using our services, you acknowledge that you have read, understood, and agree to be bound by these Terms. If you do not agree to these Terms, please do not access or use our services.</p>
          </section>
          
          <section className="terms-section">
            <h4>2. Rental Services</h4>
            
            <h5>2.1 Rental Reservations</h5>
            <p>When you make a reservation through our website or by phone, you are creating a legally binding offer to rent equipment subject to these Terms. All reservations are subject to availability and our acceptance.</p>
            
            <h5>2.2 Rental Period</h5>
            <p>The rental period begins when the equipment is delivered or picked up and ends when the equipment is picked up by us or returned by you, as specified in your rental agreement. Additional fees will apply for late returns.</p>
            
            <h5>2.3 Rental Fees and Payments</h5>
            <p>All prices are quoted in US dollars and do not include applicable taxes. A deposit is required to confirm your reservation. Final payment is due before or upon delivery unless other arrangements have been made. We accept major credit cards, cash, and other payment methods as specified on our website.</p>
            
            <h5>2.4 Cancellations and Refunds</h5>
            <p>Cancellation policies vary by rental type and timeframe:</p>
            <ul>
              <li>Cancellations made 14+ days before the event: Full refund of deposit</li>
              <li>Cancellations made 7-13 days before the event: 50% refund of deposit</li>
              <li>Cancellations made less than 7 days before the event: No refund</li>
            </ul>
            <p>Weather-related cancellations are handled case-by-case. We reserve the right to cancel rentals due to unsafe conditions, in which case a full refund will be provided.</p>
          </section>
          
          <section className="terms-section">
            <h4>3. User Responsibilities</h4>
            
            <h5>3.1 Safe Use and Operation</h5>
            <p>You agree to:</p>
            <ul>
              <li>Use the equipment properly and for its intended purpose</li>
              <li>Follow all safety instructions provided</li>
              <li>Provide adult supervision for all inflatable equipment at all times</li>
              <li>Not allow food, drink, shoes, eyeglasses, or sharp objects in inflatable equipment</li>
              <li>Not move equipment once it has been set up by our staff</li>
            </ul>
            
            <h5>3.2 Site Requirements</h5>
            <p>You are responsible for:</p>
            <ul>
              <li>Providing adequate space for equipment setup (dimensions provided upon reservation)</li>
              <li>Ensuring a flat, clean surface for installation</li>
              <li>Identifying and marking underground utilities before delivery</li>
              <li>Providing access to electrical outlets (within 100 feet) for inflatable equipment</li>
              <li>Obtaining necessary permits if required by your location</li>
            </ul>
            
            <h5>3.3 Liability for Damage</h5>
            <p>You are responsible for all damage to rental equipment beyond normal wear and tear. This includes tears, punctures, water damage, excessive soiling, or damage from improper use. Repair or replacement costs will be charged to your payment method on file.</p>
          </section>
          
          <section className="terms-section">
            <h4>4. Limitation of Liability</h4>
            <p>To the fullest extent permitted by law, RoweBros Party Rentals, its officers, employees, and agents will not be liable for any indirect, incidental, special, consequential, or punitive damages, including but not limited to personal injuries, property damage, loss of use, or loss of income or profits.</p>
            <p>You agree to indemnify and hold harmless RoweBros Party Rentals from any claims, damages, liabilities, and expenses arising from your use of our equipment or breach of these Terms.</p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsModal; 